.input {
  border-radius: var(--mantine-spacing-xs);

  &:not([disabled]) {
    &:focus,
    &:focus-within,
    &:active {
      outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
    }
  }

  &:not([data-error]) {
    &:focus,
    &:focus-within,
    &:active {
      border-color: var(--mantine-color-primary-filled);
    }
  }

  &[data-error] {
    color: var(--mantine-color-danger-7);
    background-color: var(--mantine-color-danger-0);
    border-color: var(--mantine-color-danger-7);

    &::placeholder {
      color: var(--mantine-color-danger-7);
    }
  }
}
